import * as React from "react";
import {
  HoldingsInformation,
  ResourceDWR,
  TextualHolding,
} from "../../../dto/SuggestionResult";
import { useLocalHoldingsBranch } from "./LocalHoldingsBranch";
import { useLanguage } from "../../Language";
import { TextualHoldings } from "./TextualHoldings";
import { NonSerialHoldings } from "./NonSerialHoldings";
import { SerialHoldings } from "./SerialHoldings";
import { Button, Link } from "@mui/material";

export interface LocalCopiesProps {
  resource: ResourceDWR;
}
export const LocalCopies: React.FC<LocalCopiesProps> = ({ resource }) => {
  const { branchIdentifier: localHoldingsBranchId } = useLocalHoldingsBranch();
  const { translate } = useLanguage();
  const holdingsCutoff = 5;
  const allCopiesURL = `#section=resource&resourceid=${resource.id}&view=allCopiesDetailsTab`;

  const holdings = resource.holdingsInformations.filter((holding) => {
    return (
      localHoldingsBranchId &&
      holding.branchIdentifier === localHoldingsBranchId &&
      !holding.serialItem
    );
  });
  const textualHoldings = resource.textualHoldings.filter((holding) => {
    return (
      localHoldingsBranchId &&
      holding.branchIdentifier === localHoldingsBranchId
    );
  });
  const serialHoldings = resource.holdingsInformations.filter((holding) => {
    return (
      localHoldingsBranchId &&
      holding.branchIdentifier === localHoldingsBranchId &&
      holding.serialItem
    );
  });

  // Derive branch name from any of the holdings, if available
  const branchName =
    holdings[0]?.branchName ||
    textualHoldings[0]?.branchName ||
    serialHoldings[0]?.branchName ||
    null;

  const showCheckOtherLocations =
    localHoldingsBranchId &&
    [...resource.holdingsInformations, ...resource.textualHoldings].some(
      (holding) => holding.branchIdentifier !== localHoldingsBranchId
    );

  const allCopiesLink = (
    holdings: HoldingsInformation[] | TextualHolding[]
  ) => {
    return holdings.length > holdingsCutoff ? (
      <Button component={Link} href={allCopiesURL} className="allCopies">
        {translate("viewAllCopies")}
      </Button>
    ) : null;
  };

  return (
    <>
      {branchName && (
        <div style={{ marginBottom: 50, fontSize: "0.95em" }}>
          <h3 style={{ fontSize: 16 }}>
            {translate("findOnShelf")} {translate("availability_at")}{" "}
            {branchName}
            {showCheckOtherLocations && (
              <span>
                <Button
                  component={Link}
                  href={allCopiesURL}
                  className="allCopies"
                >
                  {translate("availability_checkOtherLocations")}
                </Button>
              </span>
            )}
          </h3>
          {textualHoldings.length > 0 && (
            <>
              <TextualHoldings
                holdings={textualHoldings.slice(0, holdingsCutoff)}
              />
              {allCopiesLink(textualHoldings)}
            </>
          )}
          {holdings.length > 0 && (
            <>
              <NonSerialHoldings
                resource={resource}
                holdings={holdings.slice(0, holdingsCutoff)}
              />
              {allCopiesLink(holdings)}
            </>
          )}
          {serialHoldings.length > 0 && (
            <>
              <SerialHoldings
                resource={resource}
                holdings={serialHoldings.slice(0, holdingsCutoff)}
              />
              {allCopiesLink(serialHoldings)}
            </>
          )}
        </div>
      )}
    </>
  );
};
